import type { CadenceStatus, CadenceTask } from "../../api/cadence.ts";
import { LeadHistoryPanel } from "./LeadHistoryPanel.tsx";
import { TaskList } from "./TaskList.tsx";

type DayPanelProps = {
  selectedDate: string;
  loading: boolean;
  selectedTasks: CadenceTask[];
  todayTasks: CadenceTask[];
  showTodayTasks: boolean;
  busyTaskId: number | null;
  historyLeadId: string;
  historyLeadName: string;
  historyTasks: CadenceTask[];
  historyLoading: boolean;
  onStatus: (taskId: number, status: CadenceStatus) => void;
  onOpenConversation: (task: CadenceTask) => void;
  onReschedule: (task: CadenceTask) => void;
  onHistory: (task: CadenceTask) => void;
  onDelete: (taskId: number) => void;
  onCloseHistory: () => void;
};

export function DayPanel({
  selectedDate,
  loading,
  selectedTasks,
  todayTasks,
  showTodayTasks,
  busyTaskId,
  historyLeadId,
  historyLeadName,
  historyTasks,
  historyLoading,
  onStatus,
  onOpenConversation,
  onReschedule,
  onHistory,
  onDelete,
  onCloseHistory,
}: DayPanelProps) {
  return (
    <aside className="cadence-panel" aria-label="Agendar cadencia">
      <div className="cadence-panel-head">
        <div>
          <span className="cadence-eyebrow">Dia selecionado</span>
          <h2>{selectedDate}</h2>
        </div>
        {loading ? <span className="cadence-loading">Carregando...</span> : null}
      </div>

      <TaskList
        tasks={selectedTasks}
        busyTaskId={busyTaskId}
        onStatus={onStatus}
        onOpenConversation={onOpenConversation}
        onReschedule={onReschedule}
        onHistory={onHistory}
        onDelete={onDelete}
      />

      {showTodayTasks ? (
        <section className="cadence-today-list" aria-label="Pendencias de hoje">
          <div className="cadence-panel-head">
            <div>
              <span className="cadence-eyebrow">Hoje</span>
              <h2>Pendencias</h2>
            </div>
          </div>
          <TaskList
            tasks={todayTasks}
            busyTaskId={busyTaskId}
            onStatus={onStatus}
            onOpenConversation={onOpenConversation}
            onReschedule={onReschedule}
            onHistory={onHistory}
            onDelete={onDelete}
          />
        </section>
      ) : null}

      {historyLeadId ? (
        <LeadHistoryPanel
          leadName={historyLeadName}
          tasks={historyTasks}
          loading={historyLoading}
          onClose={onCloseHistory}
        />
      ) : null}
    </aside>
  );
}
